import React from 'react'
import "./Hero.css"

// import mobileLoader from "../../assets/Sharvil loader mobile.gif"
function AnimateHer() {
    return (
        <div className='animateHero'>

            <video src="Loader_2.mp4" className='animateHeroDesk' autoPlay playsInline muted preload="true">

            </video>


            <img className='animateHeroMob' src='Sharvil loader mobile.gif' alt="" />

        </div>
    )
}

export default AnimateHer